import axios from "../../axios-auth";
import hash from "object-hash";
import {
  makeQueryFromObject,
  computeCustomFormatLabel
} from "../../helpers/helpers";
import { i18n } from "../../i18n.js";

const state = {
  options: {
    /* stucture should be
      format:{
        Length:{
            code:'packing_format_Length'
            label:'Length(mm)
            value:100,
            visible:true,
            index // to be used on sort display
        }
      } */
  },
  defaults: {
    // same structure as options
  },
  previewLoading: false,
  refreshGetDataPP: [],
  packingCustomFormats: {
    /*custom_10_20: {
      label: "Custom mm",
      value: "custom_10_20",
      options: {
        Length: "100",
        Width: "100",
        Depth: "100"
      }
    }*/
  },
  limits: {},
  mainWindow: null,
  prevPackingGetData: null
};

const getters = {
  getPOValueNeededForGetData: (state, getters) => {
    if (getters.getIsChangeOptionsEmpty) {
      return {};
    }
    const allPageOptions = getters.getAllProductPageOptions(true);
    const data = {};
    for (let refreshPo in getters.getRefreshGetDataPP) {
      const refreshItem = getters.getRefreshGetDataPP[refreshPo];
      data[refreshItem] = allPageOptions[refreshItem].selected[0];
    }
    return data;
  },
  getPrevPackingGetData: state => {
    return state.prevPackingGetData;
  },
  getMainWindow: state => {
    return state.mainWindow;
  },
  getDownloadFileName: (state, getters) => {
    const sku = getters.getWebProductSku;
    const sku_info = sku ? "_" + sku : "";
    const options = getters.getPackingOptions;
    let prop = "";
    if (options.length > 0) {
      prop =
        "_" +
        options
          .map(el => {
            return el.value;
          })
          .join("_");
    }
    return "product" + sku_info + "_" + getters.getInputUnit + prop;
  },
  getLimits: state => {
    return state.limits;
  },
  getPreviewLoading: state => {
    return state.previewLoading;
  },
  getPackingCustomFormats: state => {
    return state.packingCustomFormats;
  },
  getRefreshGetDataPP: state => {
    return state.refreshGetDataPP;
  },
  getPackingOptions: (state, getters, rootState, rootGetters) => {
    var activeOptions = state.options;
    var options = [];
    for (var opt in activeOptions) {
      for (var item in activeOptions[opt]) {
        if (activeOptions[opt][item].visible) {
          options.push({
            code: "packing_" + opt + "_" + item,
            label: activeOptions[opt][item].label,
            value: activeOptions[opt][item].value,
            index: activeOptions[opt][item].index
          });
        }
      }
    }

    options.sort(function (a, b) {
      return a.index == b.index ? 0 : a.index > b.index ? 1 : -1;
    });
    return options;
  },

  getPackingOptionsData: state => {
    var activeOptions = state.options;
    var options = {};
    for (var opt in activeOptions) {
      for (var item in activeOptions[opt]) {
        if (
          activeOptions[opt][item].value != "" &&
          parseFloat(activeOptions[opt][item].value) != 0
        ) {
          if (activeOptions[opt][item].code == "Color") {
            options["papercolor"] = activeOptions[opt][item].value;
          } else if (activeOptions[opt][item].code == "Texture") {
            options["outsideTexture"] = activeOptions[opt][item].value;
          } else if (activeOptions[opt][item].code == "Inside_texture") {
            options["insideTexture"] = activeOptions[opt][item].value;
          } else if (activeOptions[opt][item].code == "PackingDoubleSided") {
            options["packingDoubleSided"] = activeOptions[opt][item].value;
          } else if (activeOptions[opt][item].code == "FlippedPage") {
            options["flippedPage"] = activeOptions[opt][item].value;
          } else if (
            (activeOptions[opt][item].code == "WH" ||
              activeOptions[opt][item].code == "MDS") &&
            typeof activeOptions[opt][item].value === "string"
          ) {
            options[activeOptions[opt][item].code] =
              "'" + activeOptions[opt][item].value.replaceAll("'", "") + "'";
          } else {
            options[activeOptions[opt][item].code] =
              activeOptions[opt][item].value;
          }
        }
      }
    }
    return options;
  },

  getPackingOptionsDataForGetData: (state, getters) => {
    var activeOptions = state.options;
    var packingVars = getters.getPackagingVariables;
    var options = {};
    for (var opt in activeOptions) {
      for (var item in activeOptions[opt]) {
        if (
          activeOptions[opt][item].value != "" &&
          parseFloat(activeOptions[opt][item].value) != 0
        ) {
          if (opt == "format") {
            if (!(activeOptions[opt][item].code in packingVars)) {
              continue;
            }
          }
          if (activeOptions[opt][item].code == "Color") {
            options["papercolor"] = activeOptions[opt][item].value;
          } else if (activeOptions[opt][item].code == "Texture") {
            options["outsideTexture"] = activeOptions[opt][item].value;
          } else if (activeOptions[opt][item].code == "Inside_texture") {
            options["insideTexture"] = activeOptions[opt][item].value;
          } else if (activeOptions[opt][item].code == "PackingDoubleSided") {
            options["packingDoubleSided"] = activeOptions[opt][item].value;
          } else if (activeOptions[opt][item].code == "FlippedPage") {
            options["flippedPage"] = activeOptions[opt][item].value;
          } else if (
            (activeOptions[opt][item].code == "WH" ||
              activeOptions[opt][item].code == "MDS") &&
            typeof activeOptions[opt][item].value === "string"
          ) {
            options[activeOptions[opt][item].code] =
              "'" + activeOptions[opt][item].value.replaceAll("'", "") + "'";
          } else {
            options[activeOptions[opt][item].code] =
              activeOptions[opt][item].value;
          }
        }
      }
    }
    return options;
  },

  getPackingDataForm: (state, getters) => {
    let packingDataForm = {
      model: getters.getPackagingModel,
      Thickness: 0.3,
      Input_Unit: getters.getInputUnit,
      return_type: "json",
      hide_buttons: true,
      hasTdImage: getters.getImageTd.length != 0,
      ...getters.getPackingOptionsDataForGetData
    };
    if (getters.getStoreCode) {
      packingDataForm.store_code = getters.getStoreCode;
    }
    return packingDataForm;
  },
  getPackingDownloadPdfData: (state, getters) => {
    return makeQueryFromObject({
      ...getters.getPackingDataForm,
      return_type: "download",
      filename: getters.getDownloadFileName + ".pdf",
      Show_Overall_Dimensions: 1
    });
  },
  getPackingDownloadCf2Data: (state, getters) => {
    return makeQueryFromObject({
      ...getters.getPackingDataForm,
      return_type: "download",
      filename: getters.getDownloadFileName + ".cf2"
    });
  },
  getPackingHiddenInputs: (state, getters) => {
    var packingData = {
      "print_options[packing][packaging_inputs][Input_Unit][]":
        getters.getInputUnit
    }; /*
    var activeOptions = state.options;
    for (var opt in activeOptions) {
      for (var item in activeOptions[opt]) {
        if (activeOptions[opt][item].visible) {
          packingData[
            "print_options[packing][packaging_inputs][" + item + "][]"
          ] = activeOptions[opt][item].value;
        }
      }
    }*/
    var activeOptions = getters.getPackingOptionsData;
    for (var opt in activeOptions) {
      packingData["print_options[packing][packaging_inputs][" + opt + "][]"] =
        activeOptions[opt];
    }

    // put all information for all paper types
    // maybe just for the selected one ????

    return packingData;
  },
  getExistingPackingFormat: (state, getters) => payload => {
    if (state.options["format"]) {
      // get input format options with their values
      var packingVars = getters.getPackagingVariables;
      var options = Object.keys(state.options["format"])
        .filter(item => {
          return item in packingVars;
        })
        .map(el => {
          return {
            code: [state.options["format"][el].code],
            value: state.options["format"][el].value
          };
        })
        .reduce((obj, item) => {
          obj[item.code] = item.value;
          return obj;
        }, {});

      var activeProductPageOptions = payload.getters.getAllProductPageOptions(
        true
      );

      var opt = "format";
      for (var ppValue of activeProductPageOptions[opt].values) {
        // for format we need all fields, not just the selected/active ones
        var matchedAttributes = 0;
        for (var attribute in ppValue.attributes) {
          var attributeName = getAttributeName(attribute, opt);
          if (!attributeName) {
            continue;
          }

          if (
            Object.keys(options).includes(attributeName) &&
            options[attributeName] == ppValue.attributes[attribute]
          ) {
            matchedAttributes++;
          }
        }

        if (matchedAttributes == Object.keys(options).length) {
          // we found the format
          return ppValue.value;
        }
      }
      // also search in custom formats
      for (var pack in payload.getters.getPackingCustomFormats) {
        matchedAttributes = 0;

        for (var packOptions in payload.getters.getPackingCustomFormats[pack]
          .options) {
          if (
            Object.keys(options).includes(packOptions) &&
            options[packOptions] ==
              payload.getters.getPackingCustomFormats[pack].options[packOptions]
          ) {
            matchedAttributes++;
          }
        }
        if (matchedAttributes == Object.keys(options).length) {
          // we found the format
          return payload.getters.getPackingCustomFormats[pack].value;
        }
      }
    }
    return null;
  }
};

const mutations = {
  loadInitialPackingOptions: (state, { getters, rootGetters, payload }) => {
    var activeProductPageOptions = rootGetters.getAllProductPageOptions(true);
    var activeAttributes = {};
    var refreshGetDataPP = [];
    for (var opt in activeProductPageOptions) {
      for (var ppValue of activeProductPageOptions[opt].values) {
        // for format we need all fields, not just the selected/active ones

        for (var attribute in ppValue.attributes) {
          var attributeName = getAttributeName(attribute, opt);
          if (!attributeName) {
            continue;
          }

          if (!refreshGetDataPP.includes(opt)) {
            refreshGetDataPP.push(opt);
          }

          if (
            opt != "format" &&
            !activeProductPageOptions[opt].selected.includes(ppValue.value)
          ) {
            continue;
          }

          var packingFound = getPackingVariableLable(
            attributeName,
            rootGetters
          );

          if (!activeAttributes[opt]) {
            activeAttributes[opt] = {};
          }
          var value = "";
          if (opt == "format") {
            if (
              activeProductPageOptions[opt].selected.includes(ppValue.value)
            ) {
              value = ppValue.attributes[attribute];

              if (activeAttributes[opt][attributeName]) {
                activeAttributes[opt][attributeName].value = value;
                continue;
              }
            }
          } else {
            value = ppValue.attributes[attribute];
          }
          if (!activeAttributes[opt][attributeName]) {
            activeAttributes[opt][attributeName] = {
              code: attributeName,
              label: packingFound ? packingFound.label : attributeName,
              value,
              visible: packingFound ? true : false,
              index: packingFound ? packingFound.index : 9999
            };
          }
        }
      }
    }

    if (activeAttributes["format"] && state.defaults["format"]) {
      for (var optFormat in activeAttributes["format"]) {
        if (
          activeAttributes["format"][optFormat].value == "" &&
          Object.keys(state.defaults["format"]).includes(optFormat)
        ) {
          // put de default value
          activeAttributes["format"][optFormat].value =
            state.defaults["format"][optFormat].value;
        }
      }
    }

    state.options = activeAttributes;
    state.refreshGetDataPP = refreshGetDataPP;
  },

  loadPackingOption: (state, { getters, rootGetters, payload }) => {
    var activeProductPageOptions = rootGetters.getAllProductPageOptions(true);
    var activeAttributes = {};

    var opt = payload.option;
    for (var ppValue of activeProductPageOptions[payload.option].values) {
      if (activeProductPageOptions[opt].selected.includes(ppValue.value)) {
        for (var attribute in ppValue.attributes) {
          var attributeName = getAttributeName(attribute, payload.option);
          if (!attributeName) {
            continue;
          }

          var packingFound = getPackingVariableLable(
            attributeName,
            rootGetters
          );

          if (!activeAttributes[attributeName]) {
            activeAttributes[attributeName] = {
              code: attributeName,
              label: packingFound ? packingFound.label : attributeName,
              value: ppValue.attributes[attribute],
              visible: packingFound ? true : false,
              index: packingFound ? packingFound.index : 9999
            };
          }
        }

        break;
      }
    }

    // search also in custom formats
    if (payload.option == "format") {
      if (state.packingCustomFormats[payload.value]) {
        for (attribute in state.packingCustomFormats[payload.value].options) {
          attributeName = attribute;
          packingFound = getPackingVariableLable(attributeName, rootGetters);
          if (!activeAttributes[attributeName]) {
            activeAttributes[attributeName] = {
              code: attributeName,
              label: packingFound ? packingFound.label : attributeName,
              value:
                state.packingCustomFormats[payload.value].options[attribute],
              visible: true,
              index: packingFound ? packingFound.index : 9999
            };
          }
        }
      }
    }

    var options = { ...state.options };
    if (state.defaults[opt]) {
      options[opt] = state.defaults[opt];
    } else {
      options[opt] = {};
    }

    options[opt] = { ...options[opt], ...activeAttributes };
    state.options = options;
  },
  setPackingOptionValue: (state, { getters, payload }) => {
    var parts = payload.code.split("_");
    var optionCode = parts.slice(2).join("_");
    var options = { ...state.options };
    options[parts[1]][optionCode] = {
      ...options[parts[1]][optionCode],
      value: payload.value
    };
    state.options = options;
  },
  setLimits: (state, payload) => {
    state.limits = payload;
  },
  setMainWindow: (state, payload) => {
    state.mainWindow = payload;
  },
  setPreviewLoading: (state, payload) => {
    state.previewLoading = payload;
  },
  setDefaults: (state, { getters, defaultsPayload }) => {
    var defaults = {};
    for (var option in defaultsPayload) {
      var labelName = null;
      for (var packVar in getters.getPackagingVariables) {
        if (getters.getPackagingVariables[packVar].code == option) {
          labelName = getters.getPackagingVariables[packVar].label;
          break;
        }
      }
      defaults[option] = {
        code: option,
        value: defaultsPayload[option],
        label: labelName,
        visible: labelName ? true : false
      };
    }
    if (state.options["format"]) {
      for (var opt in state.options["format"]) {
        if (
          state.options["format"][opt].value == "" &&
          Object.keys(defaults).includes(opt)
        ) {
          // put de default value
          state.options["format"][opt].value = defaults[opt].value;
        }
      }
    } else {
      state.options["format"] = {};
    }
    state.defaults["format"] = defaults;
  },
  insertNewPackingCustomFormat: (state, { getters, formatPayload, code }) => {
    var packingVars = getters.getPackagingVariables;
    var formatOptions = Object.keys(state.options["format"])
      .filter(item => {
        return item in packingVars;
      })
      .map(el => {
        return { label: el, value: state.options["format"][el].value };
      })
      .reduce((obj, item) => {
        obj[item.label] = item.value;
        return obj;
      }, {});
    var newCustomType = {
      [code]: {
        label: computeCustomFormatLabel(
          getters.getMeasurementSystem,
          formatPayload.width,
          formatPayload.height
        ),
        value: code,
        options: { ...formatOptions }
      }
    };
    state.packingCustomFormats = {
      ...state.packingCustomFormats,
      ...newCustomType
    };
  },
  setPrevPackingGetData: (state, payload) => {
    state.prevPackingGetData = payload;
  }
};

const actions = {
  loadInitialPackingOptions: ({ commit, getters, rootGetters }, payload) => {
    commit("loadInitialPackingOptions", {
      getters,
      rootGetters,
      payload
    });
  },
  setPackingOption: ({ commit, getters, rootGetters }, payload) => {
    if (payload.code) {
      commit("setPackingOptionValue", {
        getters,
        payload
      });
    } else {
      commit("loadPackingOption", { getters, rootGetters, payload });
    }
  },
  packingGetData: (
    { commit, getters, dispatch, state, rootState },
    payload
  ) => {
    var sendData = getters.getPackingDataForm;
    //cache getData call
    if (hash(sendData) == getters.getPrevPackingGetData) {
      // same hash ... no need to call again getData
      if (payload.setLoading) {
        dispatch("setIsLoading", false);
      }
      return;
    }

    commit("setPreviewLoading", true);

    var existingPackingFormat = getters.getExistingPackingFormat({ getters });
    if (existingPackingFormat) {
      dispatch("setPageOptionFormat", {
        option: "format",
        value: existingPackingFormat
      });
    }

    if (getters.getPreview3D) {
      jQuery("#" + getters.get3DPreviewId + " iframe")
        .get(0)
        .contentWindow.postMessage(
          JSON.stringify({
            changeDimension: sendData
          }),
          "*"
        );
    }

    axios.instance
      .get(getters.getUrl(axios.packingGetData), {
        params: sendData
      })
      .then(response => {
        commit("setPrevPackingGetData", hash(sendData));
        if (response.data.image) {
          if (!getters.getPreview3D) {
            dispatch("setPreview3D", response.data["3DUrl"]);
          }
          dispatch("setPreview2D", response.data.image);

          commit("setDefaults", {
            getters,
            defaultsPayload: response.data.defaults
          });

          commit("setLimits", response.data.limits);

          // insert the new format if it does not exist
          if (!existingPackingFormat) {
            var new_code =
              "custom_" +
              response.data.format.width +
              "_" +
              response.data.format.height;
            commit("insertNewPackingCustomFormat", {
              getters,
              formatPayload: response.data.format,
              code: new_code
            });
            dispatch("setPageOptionFormat", {
              option: "format",
              value: new_code
            });
          }

          if (payload && payload.callChangeOptions) {
            dispatch("changeOptions", {});
          }

          if (payload.setLoading) {
            dispatch("setIsLoading", false);
          }

          commit("setPreviewLoading", false);
        } else {
          if (payload.setLoading) {
            dispatch("setIsLoading", false);
          }
          var wnd = payload.wnd || getters.getMainWindow;
          if (response.data.message && payload && wnd) {
            wnd.$swal({
              text: response.data.message,
              icon: "warning"
            });
            commit("setPreviewLoading", false);
            commit("setPreview3DLoading", false);
            return;
          }
        }
      })
      .catch(error => {
        console.log("Error " + error);
        console.log(error);
        if (payload.setLoading) {
          dispatch("setIsLoading", false);
        }
        commit("setPreviewLoading", false);
      });
  },
  packingDownloadPdf: ({ commit, getters, dispatch }, payload) => {
    window.location =
      getters.getUrl(axios.packingGetPdf) +
      "?" +
      getters.getPackingDownloadPdfData;
  },
  packingDownloadCf2: ({ commit, getters, dispatch }, payload) => {
    window.location =
      getters.getUrl(axios.packingGetCf2) +
      "?" +
      getters.getPackingDownloadCf2Data;
  },
  setMainWindow: ({ commit }, payload) => {
    commit("setMainWindow", payload);
  },
  setPrevPackingGetData: ({ commit }, payload) => {
    commit("setPrevPackingGetData", payload);
  }
};

const getAttributeName = (attribute, option) => {
  var attributeName = null;
  if (attribute.startsWith("packing_" + option)) {
    attributeName = attribute.replace("packing_" + option + "_", "");
  } else if (attribute.startsWith("packaging")) {
    attributeName = attribute.replace("packaging_", "");
  } else if (attribute == "packing_value") {
    attributeName = "Thickness";
  } else if (attribute == "packing_double_sided") {
    attributeName = "packingDoubleSided";
  } else if (attribute == "packing_flipped_page") {
    attributeName = "flippedPage";
  } else {
    return null;
  }

  attributeName =
    attributeName.charAt(0).toUpperCase() + attributeName.slice(1);
  if (attributeName == "Wh") {
    attributeName = "WH";
  }
  if (attributeName == "Mds") {
    attributeName = "MDS";
  }
  return attributeName;
};

const getPackingVariableLable = (attributeName, rootGetters) => {
  var counter = 0;
  for (var packVar in rootGetters.getPackagingVariables) {
    if (rootGetters.getPackagingVariables[packVar].code == attributeName) {
      return {
        label: rootGetters.getPackagingVariables[packVar].label,
        index: counter
      };
    }
    counter++;
  }
  return null;
};

export default {
  state,
  mutations,
  actions,
  getters
};
